import { getEmailSignatureHyperlink } from '@common/utils/linkify';

export function convertToHtml(str: string | null | undefined): string {
    return getEmailSignatureHyperlink(str)
        .replace(/<a href="mailto:([^"]+)">/g, '<a href="mailto:$1" class="highlighted-email">')
        .replace(
            /<a href="([^"]+)" target="_blank">/g,
            '<a href="$1" target="_blank" class="highlighted-url">',
        );
}
